import "../../i18n/i18n";
import { VehiclesTable } from "./vehiclesTable";
import { useVehicles } from "./useVehicles";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ButtonDS, triggerToast } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import {
  createAnalyticVehiclesToCheckTheirEgibilitiesAsync,
  selectCreateAnalyticVehiclesStatus,
} from "./telemetrySlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { Vehicle, VehicleDisplayed } from "./telemetryApi";

export const CheckVehiclesEligibilityTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const params = useParams();
  const vehiclesListWithId = useVehicles();
  const [selectedVehicles, setSelectedVehicles] = useState<VehicleDisplayed[]>(
    [],
  );
  const createAnalyticVehiclesStatus = useAppSelector(
    selectCreateAnalyticVehiclesStatus,
  );

  const filteredVehiclesListWithId = useMemo(() => {
    return vehiclesListWithId.filter(
      (v) =>
        v.isEligible &&
        v.isEligible.toString() ===
          t("vehiclesOfACompany.column.isEligible.null"),
    );
  }, [t, vehiclesListWithId]);

  const checkVehiclesEligibility = useCallback(() => {
    const selectedVehiclesPayload = selectedVehicles
      .map((vp) => {
        const analyticsVehicle = vp as unknown as Vehicle;
        const vehicle = vehiclesListWithId.find(
          (v) => v.uuid === analyticsVehicle.uuid,
        );

        if (
          !vehicle ||
          !vehicle.registrationNumber ||
          params.id === undefined
        ) {
          return null;
        }

        return {
          companyUuid: params.id,
          vehicleUuid: analyticsVehicle.uuid,
          registrationNumber: vehicle.registrationNumber,
          department: vehicle.department,
        };
      })
      .filter((v) => v !== null);

    void dispatch(
      createAnalyticVehiclesToCheckTheirEgibilitiesAsync(
        selectedVehiclesPayload,
      ),
    );
  }, [selectedVehicles, vehiclesListWithId, params.id, dispatch]);

  const checkVehiclesEligibilityAction = useMemo(() => {
    return (
      <ButtonDS
        text={t("telemetry.checkVehiclesEligibility.button")}
        format="fill"
        buttonType="primary"
        onClick={checkVehiclesEligibility}
        disabled={selectedVehicles.length === 0}
      />
    );
  }, [t, checkVehiclesEligibility, selectedVehicles.length]);

  useEffect(() => {
    if (createAnalyticVehiclesStatus === "success") {
      triggerToast(
        t("telemetry.checkVehiclesEligibility.success") || "",
        "valid",
      );
    } else if (createAnalyticVehiclesStatus === "failed") {
      triggerToast(
        t("telemetry.checkVehiclesEligibility.failure") || "",
        "error",
      );
    }
  }, [createAnalyticVehiclesStatus, t]);

  if (params.tab !== "checkVehiclesEligibility") {
    return;
  }

  return (
    <VehiclesTable
      vehiclesListWithId={filteredVehiclesListWithId}
      pageName="vehiclesOfACompany"
      pageTitle="Check-Vehicles-of-a-Company-Eligibility"
      action={checkVehiclesEligibilityAction}
      rowsChecked={selectedVehicles}
      setRowsChecked={setSelectedVehicles}
    />
  );
};
